import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=76b56a70"
import script from "./Warranty.vue?vue&type=script&lang=js"
export * from "./Warranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports